import React from "react";
import client from "@culturehq/client";
import { Icon, Panel } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { getName, Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import BuildConnection from "components/person/BuildConnection";
import styles from "./styles.module.scss";

const SimilarPeople = ({ isProfile, user }) => {
  const { fetching, json } = useFetch(
    () => client.listProfileSimilarPeople({ userId: user.id }),
    [user]
  );
  const { connections = [] } = json;

  const { fetching: fetchingUsers, json: users } = useFetch(
    () => client.listUsers({ community: "connections" }),
    []
  );

  const displayed = [...connections, null, null, null].slice(0, 4);

  return (
    <div className="Person--Similar-People">
      <Panel className={styles["panel-inner"]}>
        <Panel.Heading>
          <Icon icon="person-check" /><Trans>Similar people to {getName(user, isProfile)}</Trans>
        </Panel.Heading>
        <Panel.Body>
          <ErrorBoundary>
            {displayed.map((connection, index) => (
              <div key={connection ? connection.id : index} className="User">
                <div className={styles["row--conn"]}>
                  <BuildConnection
                    connection={connection}
                    fetching={fetching || fetchingUsers}
                    users={users}
                  />
                </div>
              </div>
            ))}
          </ErrorBoundary>
        </Panel.Body>
      </Panel>
    </div>
  );
};

export default SimilarPeople;
